module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#photo",
      toString: function () {
        return this.url;
      }
    }